/** Google Calendar colorId (1-11) → hex. */
const COLOR_BY_ID: Record<string, string> = {
  '1': '#7986CB',
  '2': '#33B679',
  '3': '#8E24AA',
  '4': '#E67C73',
  '5': '#F6BF26',
  '6': '#F4511E',
  '7': '#039BE5',
  '8': '#616161',
  '9': '#3F51B5',
  '10': '#0B8043',
  '11': '#D50000',
};

const FALLBACK_COLOR = '#039BE5';

export const colorForId = (colorId: string): string =>
  COLOR_BY_ID[colorId] ?? FALLBACK_COLOR;
